/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Referral } from './Referral';
import {
    ReferralFromJSON,
    ReferralFromJSONTyped,
    ReferralToJSON,
    ReferralToJSONTyped,
} from './Referral';
import type { RecipientStatus } from './RecipientStatus';
import {
    RecipientStatusFromJSON,
    RecipientStatusFromJSONTyped,
    RecipientStatusToJSON,
    RecipientStatusToJSONTyped,
} from './RecipientStatus';

/**
 * 
 * @export
 * @interface InboundReferralItem
 */
export interface InboundReferralItem {
    /**
     * 
     * @type {string}
     * @memberof InboundReferralItem
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof InboundReferralItem
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof InboundReferralItem
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof InboundReferralItem
     */
    facility_name?: string;
    /**
     * Real provider_directory identifier. Null for an "other" recipient (a name+email contact with no directory-backed identity) — the only reliable "other" signal available to clients.
     * @type {string}
     * @memberof InboundReferralItem
     */
    provider_id?: string;
    /**
     * 
     * @type {RecipientStatus}
     * @memberof InboundReferralItem
     */
    status: RecipientStatus;
    /**
     * 
     * @type {Date}
     * @memberof InboundReferralItem
     */
    created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof InboundReferralItem
     */
    updated_at: Date;
    /**
     * ULID of the most recent inbound message in this thread. Stamped by the message-create handler when the sender is a recipient facility. Lets clients render per-thread unread state without an extra query.
     * @type {string}
     * @memberof InboundReferralItem
     */
    last_inbound_message_id?: string;
    /**
     * True when this thread has an inbound message newer than the caller's read receipt for the thread. Per-thread; computed at read time from `last_inbound_message_id` vs the caller's per-thread receipt.
     * @type {boolean}
     * @memberof InboundReferralItem
     */
    has_unread?: boolean;
    /**
     * Admission tracking state for this recipient. Free-form string; null when not yet set.
     * @type {string}
     * @memberof InboundReferralItem
     */
    admission_status?: string;
    /**
     * 
     * @type {Referral}
     * @memberof InboundReferralItem
     */
    referral: Referral | null;
}



/**
 * Check if a given object implements the InboundReferralItem interface.
 */
export function instanceOfInboundReferralItem(value: object): value is InboundReferralItem {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('referral' in value) || value['referral'] === undefined) return false;
    return true;
}

export function InboundReferralItemFromJSON(json: any): InboundReferralItem {
    return InboundReferralItemFromJSONTyped(json, false);
}

export function InboundReferralItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundReferralItem {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'organization_id': json['organization_id'],
        'facility_id': json['facility_id'],
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'status': RecipientStatusFromJSON(json['status']),
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'last_inbound_message_id': json['last_inbound_message_id'] == null ? undefined : json['last_inbound_message_id'],
        'has_unread': json['has_unread'] == null ? undefined : json['has_unread'],
        'admission_status': json['admission_status'] == null ? undefined : json['admission_status'],
        'referral': ReferralFromJSON(json['referral']),
    };
}

export function InboundReferralItemToJSON(json: any): InboundReferralItem {
    return InboundReferralItemToJSONTyped(json, false);
}

export function InboundReferralItemToJSONTyped(value?: InboundReferralItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'organization_id': value['organization_id'],
        'facility_id': value['facility_id'],
        'facility_name': value['facility_name'],
        'provider_id': value['provider_id'],
        'status': RecipientStatusToJSON(value['status']),
        'created_at': ((value['created_at']).toISOString()),
        'updated_at': ((value['updated_at']).toISOString()),
        'last_inbound_message_id': value['last_inbound_message_id'],
        'has_unread': value['has_unread'],
        'admission_status': value['admission_status'],
        'referral': ReferralToJSON(value['referral']),
    };
}

